<div class="modal fade show d-block" *ngIf="showModal && config" tabindex="-1" 
     style="background-color: rgba(0,0,0,0.5);" (click)="onBackdropClick($event)">
  <div class="modal-dialog modal-dialog-centered" [class.modal-dialog-scrollable]="config.type === 'prompt'">
    <div class="modal-content">
      <div class="modal-header" [class.bg-danger]="config.danger" [class.text-white]="config.danger">
        <h5 class="modal-title">
          <i class="bi" [ngClass]="{
            'bi-exclamation-triangle-fill text-warning': config.type === 'confirm' && !config.danger,
            'bi-exclamation-octagon-fill': config.type === 'confirm' && config.danger,
            'bi-info-circle-fill text-info': config.type === 'alert',
            'bi-chat-square-text-fill text-primary': config.type === 'prompt'
          }" [class.text-white]="config.danger"></i>
          {{ config.title }}
        </h5>
        <button type="button" class="btn-close" [class.btn-close-white]="config.danger" (click)="onCancel()"></button>
      </div>
      <div class="modal-body">
        <p class="mb-3">{{ config.message }}</p>
        <div *ngIf="config.type === 'prompt'" class="form-group">
          <input 
            type="text" 
            class="form-control" 
            [(ngModel)]="inputValue" 
            [placeholder]="config.inputPlaceholder || 'Enter value...'"
            (keyup.enter)="onConfirm()"
            autofocus>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="onCancel()" *ngIf="config.type !== 'alert'">
          {{ config.cancelText || 'Cancel' }}
        </button>
        <button type="button" 
                class="btn" 
                [ngClass]="config.danger ? 'btn-danger' : 'btn-primary'" 
                (click)="onConfirm()">
          {{ config.confirmText || 'OK' }}
        </button>
      </div>
    </div>
  </div>
</div>
